(function ($) {
    $(() => {
        const mobilMenu = document.querySelector(".mobile-menu-wrapper");

        $('.bt-menu-trigger').on('click', function () {
            $(this).toggleClass('is-active');
            $('.mobile-menu-wrapper ').toggleClass('is-shown');
            $('.mobil-header-layer').toggleClass('mobile-menu-active');
            $('#menu').toggleClass('mobile-show');

            if ($('.mobile-menu-wrapper').hasClass('is-shown')) {
                bodyScrollLock.disableBodyScroll(mobilMenu);
            } else {
                bodyScrollLock.enableBodyScroll(mobilMenu);
            }

        });

        $(document).on('click','.mobil-header-layer.mobile-menu-active', function (e) {
            e.preventDefault();
            $('.bt-menu-trigger').click();
        })

    });
})(jQuery);
